import { render } from "./FormRoofAtticView.vue?vue&type=template&id=cd3e2968"
import script from "./FormRoofAtticView.vue?vue&type=script&lang=js"
export * from "./FormRoofAtticView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__